import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import api from "../lib/api";
import { Trophy, Loader2 } from "lucide-react";

export default function Leaderboard() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/leaderboard").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div className="min-h-screen bg-tribal">
      <Navbar />
      <main className="max-w-3xl mx-auto px-6 py-12 fade-up">
        <p className="text-xs tracking-[0.3em] text-[color:var(--primary)] mb-3">CLASSEMENT</p>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-6 flex items-center gap-3">
          <Trophy className="text-[color:var(--primary)]" /> Top 20 Ari'i
        </h1>

        <div className="glass rounded-lg overflow-hidden" data-testid="leaderboard-table">
          <div className="grid grid-cols-[40px_1fr_80px_80px_80px_80px] gap-3 px-5 py-3 border-b border-[color:var(--border)] text-xs tracking-[0.2em] text-[color:var(--text-secondary)]">
            <div>#</div>
            <div>JOUEUR</div>
            <div className="text-right">ELO</div>
            <div className="text-right">V</div>
            <div className="text-right">D</div>
            <div className="text-right">N</div>
          </div>
          {items === null && (
            <div className="px-5 py-10 text-center text-sm text-[color:var(--text-secondary)] flex items-center justify-center gap-2">
              <Loader2 className="animate-spin" size={16} /> Chargement…
            </div>
          )}
          {items && items.length === 0 && (
            <div className="px-5 py-10 text-center text-sm text-[color:var(--text-secondary)]">
              Aucun joueur classé pour le moment.
            </div>
          )}
          {items?.map((u, i) => (
            <div
              key={u.id}
              className="grid grid-cols-[40px_1fr_80px_80px_80px_80px] gap-3 px-5 py-3 border-b border-[color:var(--border)] last:border-0 text-sm items-center"
              data-testid={`leaderboard-row-${i}`}
            >
              <div className="font-semibold text-[color:var(--primary)]">{i + 1}</div>
              <div className="font-medium">{u.name}</div>
              <div className="text-right font-semibold">{u.elo}</div>
              <div className="text-right text-emerald-400">{u.wins}</div>
              <div className="text-right text-rose-400">{u.losses}</div>
              <div className="text-right text-[color:var(--text-secondary)]">{u.draws}</div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
